import { createAsyncTypes } from '../utils'

export const getLocationInfoTypes = createAsyncTypes('GET_LOCATION_INFO')
export const getLocationPropertiesTypes = createAsyncTypes(
  'GET_LOCATION_PROPERTIES'
)
export const getClosestLocationsTypes = createAsyncTypes(
  'GET_CLOSEST_LOCATIONS'
)
